'use strict';

import React, { useEffect, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import getFormStatus from '@/Form/Functions/getFormStatus'

import ServiceForm from '@/Form/ServiceForm'

import request from '@function/ajax/request'

import Link from '@Pure/Link'

import FormsStore from '@Store/Forms'

const FORM_NAME = 'ServiceForm';

export default PageWrapper(function NewServicePage (props)
{
	const [status, setStatus] = useState({ });
	const [loaded, setLoaded] = useState(false);

	useEffect(function ()
	{
		const controller = new AbortController();

		const id =  document.location.pathname
		.slice( document.location.pathname.lastIndexOf('/')+1);

		(async function ()
		{
			setLoaded(false);

			try
			{
				var { service } = await request('/services/get-one')
				.config({ controller, keyword: 'ressource' })
				.post({ id: id });
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				return setStatus(update);
			}

			FormsStore.update(function (store)
			{
				store[FORM_NAME] =
				{
					id: service.id,

					title: service.title,
					accounting_code: service.accounting_code,
					amount: String(service.amount)
				};
			});

			setLoaded(true);
		})();

		return () => controller?.abort?.();
	},
	[]);

	return (
		<Layout page_title="Service" history={ props.history }>

			<div className="page-content">

				<div className="u-flex u-content-end u-margin-bottom-20">
					<Link href="/gestion-des-services"
						className="c-btn u-no-margin-top">
						Retour aux services
					</Link>
				</div>

				{ loaded ? <ServiceForm type="update" /> : undefined }

				{ getFormStatus(status) }

			</div>

		</Layout>
	);
});